/**
 * Pure helpers for CustomMap sensor marker icon HTML.
 * Extracted so icon selection rules are unit-testable without Leaflet/webpack.
 */

const SPECIAL_SENSOR_BORDER_COLOR = '#4D5674';

const buildSpecialSensorCircleHtml = (borderColor, svgInnerHtml) =>
  `<div style="background: white;border-radius: 50px;height: 32px;width: 32px;position: relative;display: flex;justify-content: center;align-items: center;border: 2px solid ${borderColor}">${svgInnerHtml}</div>`;

const buildFlowMeterSvg = (fill) =>
  `<svg width="10" height="40" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7 7H0V5H7C8.65685 5 10 6.34315 10 8V11H8V8C8 7.44772 7.55228 7 7 7Z" fill="${fill}"/>
<path d="M10 13C10 13.5523 9.55229 14 9 14C8.44771 14 8 13.5523 8 13C8 12.4477 8.44771 12 9 12C9.55229 12 10 12.4477 10 13Z" fill="${fill}"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1 0H8V2H5.5V4H3.5V2H1V0Z" fill="${fill}"/>
</svg>`;

// Glyphs from sciroot-mobile/resources/images/icons/map/PiezometerSensorIcon.js
const buildPiezometerSvg = (fill) =>
  `<svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8 13.9291C11.3923 13.4439 14 10.5265 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.5265 2.60771 13.4439 6 13.9291V16H8V13.9291ZM12 7C12 9.76142 9.76142 12 7 12C4.23858 12 2 9.76142 2 7C2 4.23858 4.23858 2 7 2C9.76142 2 12 4.23858 12 7Z" fill="${fill}"/>
<path d="M7.35263 5.13798C7.29654 5.16744 7.23262 5.17762 7.16952 5.1718C6.64489 5.12345 6.10343 5.3001 5.70177 5.70176C4.98477 6.41876 4.98477 7.58124 5.70177 8.29824C6.41877 9.01524 7.58125 9.01524 8.29825 8.29824C8.7 7.8965 8.87664 7.35489 8.82818 6.83015C8.82235 6.76704 8.83252 6.70309 8.86199 6.64698L10.0833 4.3216C10.2202 4.06095 9.9389 3.77961 9.67824 3.91651L7.35263 5.13798Z" fill="${fill}"/>
</svg>`;

const buildColorPinHtml = (fillColor) =>
  `<svg width="24" height="33" viewBox="0 0 24 33" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 1C18.0964 1 23 5.82654 23 11.7333C23 12.7889 22.6103 14.2129 21.8954 15.8937C21.1898 17.5526 20.2074 19.3708 19.1118 21.1857C16.9215 24.8143 14.3253 28.3534 12.7209 30.4542C12.3502 30.9396 11.6498 30.9396 11.2791 30.4542C9.67466 28.3534 7.07855 24.8143 4.88816 21.1857C3.79259 19.3708 2.81022 17.5526 2.1046 15.8937C1.38967 14.2129 1 12.7889 1 11.7333C1 5.82654 5.90356 1 12 1Z" fill=${fillColor} stroke="white" stroke-width="2"/>
<circle cx="12" cy="12" r="4.5" fill="white"/>
</svg>`;

const isPressureSensorType = (type) =>
  type === 'high_pressure' || type === 'low_pressure';

const buildSelectedFieldMarkerIconHtml = ({ info, color, type }) => {
  if (info === 'Flow Meter Sensor') {
    return buildSpecialSensorCircleHtml(
      SPECIAL_SENSOR_BORDER_COLOR,
      buildFlowMeterSvg(SPECIAL_SENSOR_BORDER_COLOR),
    );
  }

  if (info === 'Piezometer Sensor' || isPressureSensorType(type)) {
    return buildSpecialSensorCircleHtml(
      SPECIAL_SENSOR_BORDER_COLOR,
      buildPiezometerSvg(SPECIAL_SENSOR_BORDER_COLOR),
    );
  }
  return buildColorPinHtml(color || 'grey');
};

const buildUnselectedFieldMarkerIconHtml = () => buildColorPinHtml('grey');

module.exports = {
  SPECIAL_SENSOR_BORDER_COLOR,
  isPressureSensorType,
  buildSelectedFieldMarkerIconHtml,
  buildUnselectedFieldMarkerIconHtml,
};
